import { render, staticRenderFns } from "./EdiPage.vue?vue&type=template&id=36218bfe"
import script from "./EdiPage.vue?vue&type=script&lang=js"
export * from "./EdiPage.vue?vue&type=script&lang=js"
import style0 from "./EdiPage.vue?vue&type=style&index=0&id=36218bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports